"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoutingProfiles = function () {
  function RoutingProfiles($q, API) {
    _classCallCheck(this, RoutingProfiles);

    this.$q = $q;
    this.API = API;
  }

  //Given a vehicle id, get all routing profiles associated with all this vehicle's vehicle groups


  _createClass(RoutingProfiles, [{
    key: "getVehicleRoutingProfiles",
    value: function getVehicleRoutingProfiles(vehicleId, options) {
      var deferred = this.$q.defer();
      var url = "v1/vehicle-groups?vehicleId=" + vehicleId;

      var that = this;

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise.then(function (results) {
        var vgPromises = _.map(results, function (result) {
          return that.getRoutingProfiles(result.id, options);
        });
        return that.$q.all(vgPromises).then(function (rpArrayOfArrays) {
          var rpFlatArray = [].concat.apply([], rpArrayOfArrays);
          rpFlatArray = _.uniq(rpFlatArray, function (rp) {
            return rp.routingProfileId;
          });
          //console.log("VEHICLE ROUTING PROFILES:");
          //console.log(rpFlatArray);
          return rpFlatArray;
        }, function (error) {
          console.log(error);
          return null;
        });
      }, function (error) {
        console.log(error);
        return null;
      });
    }
  }, {
    key: "getRoutingProfiles",
    value: function getRoutingProfiles(vehicleGroupId, options) {
      var deferred = this.$q.defer();
      var url = "v1/routing-profiles?includeGroupId=" + vehicleGroupId;

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getRoutingProfile",
    value: function getRoutingProfile(routingProfileId, options) {
      var deferred = this.$q.defer();
      var url = "v1/routing-profiles/" + routingProfileId;

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getDefaultRoutingProfile",
    value: function getDefaultRoutingProfile(options) {
      var deferred = this.$q.defer();
      var url = "v1/routing-profiles?isDefault=true";

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return RoutingProfiles;
}();

exports.default = RoutingProfiles;


RoutingProfiles.$inject = ["$q", "FleetPortalAPI"];


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.routing-profiles.js